import { useCallback } from 'react';
import { useRouter } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A custom hook to reset the initial state of navigation when changing the authentication status.
 *
 * To prevent additional network queries and state updates when the auth status changes,
 * it closes all main tabs screens that might be active in the background and replaces
 * the `MainTabs` screen with the initial (`Home`) screen.
 *
 * Should be initiated immediately following auth state change (sign-in, sign-up verification).
 */
export const useCloseActiveScreensOnAuthStatusChange = () => {
  const router = useRouter();

  return useCallback(() => {
    router.replace('/');
  }, [router]);
};
